import React, { useContext, useState } from "react";
import { Sun, Moon, ArrowLeft } from "react-feather";
import { Link } from "@reach/router";
import ThemeContext, { AppTheme } from "../../context/ThemeContext";

const Header = ({ fetchStories, path }) => {
  const [theme, setTheme] = useContext(ThemeContext);
  const [active, setActive] = useState("top");
  const [position, setPosition] = useState(20);
  const currentTheme = AppTheme[theme];

  const changeTab = key => {
    setActive(key);
    fetchStories(key);
    if (key === "top") {
      setPosition(20);
    }
    if (key === "new") {
      setPosition(82);
    } else if (key === "best") {
      setPosition(130);
    }
  };

  return (
    <div className="header" style={{ backgroundColor: `${currentTheme.background}` }}>
      {path === "/" ? (
        <div className="tabs">
          <div>
            <span className="tab" style={{ opacity: active === "top" ? 1 : 0.4 }} onClick={() => changeTab("top")}>
              Trending
            </span>
            <span className="tab" style={{ opacity: active === "new" ? 1 : 0.4 }} onClick={() => changeTab("new")}>
              New
            </span>
            <span className="tab" style={{ opacity: active === "best" ? 1 : 0.4 }} onClick={() => changeTab("best")}>
              Best
            </span>
          </div>
          <div className="highlighter" style={{ transform: `translateX(${position}px)` }} />
        </div>
      ) : (
        <Link className="back" to="/">
          <ArrowLeft className="back-arrow" />
        </Link>
      )}

      <div
        className="theme-toggle"
        onClick={() => {
          setTheme(theme === "light" ? "dark" : "light");
        }}
      >
        {theme === "light" ? <Moon /> : <Sun />}
      </div>
    </div>
  );
};

export default Header;
